import React, { useState, useCallback } from "react";

// Компонент для переключення між двома компонентами
const ToggleWrapper = React.memo(({ buttonText, buttonClassName, children }) => {
  const [open, setOpen] = useState(false);

  const openToggle = useCallback(() => setOpen(true), []);
  const closeToggle = useCallback(() => setOpen(false), []);

  // Якщо кнопка не натиснута, відображаємо її
  if (!open) {
    return (
      <button onClick={openToggle} className={buttonClassName}>
        {buttonText}
      </button>
    );
  }

  return <>{children(closeToggle)}</>;
});

export default ToggleWrapper;
